import type {
  InboxWorkflowCellComponent,
  InboxWorkflowFlowConfig,
} from "@kontextwerk/control-web-frame/inbox-workflow/contract"
import {
  buildFlowSteps,
  withHelp,
  workflowDefinition,
  workflowStep,
} from "../../_shared/_logic/registry-composition"
import { inboxWorkflowHelpDialogIds } from "../../_shared/_logic/help-dialog-ids"
import { assignWorkOrderCells, createAssignWorkOrderStep } from "./steps/01_assign_work_order"
import {
  assignRequesterCustomerCells,
  createAssignRequesterCustomerStep,
} from "./steps/02_assign_requester_customer"
import PlanAppointmentStep from "./steps/03_plan_appointment"
import InformCustomerStep from "./steps/04_inform_customer"

export const unclearAppointmentFeedbackCells: Record<string, InboxWorkflowCellComponent> = {
  ...assignWorkOrderCells,
  ...assignRequesterCustomerCells,
}

export const unclearAppointmentFeedbackFlow: InboxWorkflowFlowConfig = {
  definition: workflowDefinition({
    flowKey: "unclear_appointment_feedback",
    label: "Unklaren Terminrücklauf klären",
    subjectPolicy: "OPTIONAL",
    requirements: [
      "ASSIGN_OR_CREATE_WORK_ORDER",
      "ASSIGN_REQUESTER_CUSTOMER",
      "PLAN_APPOINTMENT",
      "INFORM_CUSTOMER",
    ],
    steps: [
      workflowStep({
        stepKey: "assign_work_order",
        label: "Passenden Auftrag auswählen",
        componentKey: "work_order_assignment_surface.assign_work_order",
        requirements: ["ASSIGN_OR_CREATE_WORK_ORDER"],
        outputKey: "work_order",
      }),
      workflowStep({
        stepKey: "assign_requester_customer",
        label: "Anfragenden Ansprechpartner festlegen",
        componentKey: "work_order_assignment_surface.assign_requester_customer",
        requirements: ["ASSIGN_REQUESTER_CUSTOMER"],
        outputKey: "requester_customer",
      }),
      workflowStep({
        stepKey: "plan_appointment",
        label: "Termin planen",
        componentKey: "work_order_assignment_surface.plan_appointment",
        requirements: ["PLAN_APPOINTMENT"],
        outputKey: "planned_appointment",
      }),
      workflowStep({
        stepKey: "inform_customer",
        label: "Kunden informieren",
        componentKey: "contact_order_planning.inform_customer",
        requirements: ["INFORM_CUSTOMER"],
        outputKey: "customer_information",
      }),
    ],
  }),
  steps: buildFlowSteps({
    assign_work_order: withHelp(
      createAssignWorkOrderStep(),
      inboxWorkflowHelpDialogIds.unclearAppointmentFeedbackAssignWorkOrder,
    ),
    assign_requester_customer: withHelp(
      createAssignRequesterCustomerStep(),
      inboxWorkflowHelpDialogIds.unclearAppointmentFeedbackAssignRequesterCustomer,
    ),
    plan_appointment: withHelp(
      {
        kind: "custom",
        component: PlanAppointmentStep,
      },
      inboxWorkflowHelpDialogIds.unclearAppointmentFeedbackPlanAppointment,
    ),
    inform_customer: withHelp(
      {
        kind: "custom",
        component: InformCustomerStep,
      },
      inboxWorkflowHelpDialogIds.unclearAppointmentFeedbackInformCustomer,
    ),
  }),
}
